import { defineCatalogue } from '../../../i18n';

export const newCampaignCatalogue = defineCatalogue(
  {
    title: 'Nova campanha',
    'name.label': 'Nome da campanha',
    'activeFrom.label': 'Início (opcional)',
    'activeTo.label': 'Fim (opcional)',
    submit: 'Criar campanha',
    'refused.reason': 'tente novamente mais tarde',
    'refused.noSlots': 'Não há vaga livre para criar uma nova campanha.',
    steps: 'Etapas',
    'step.candidate': 'Candidatura',
    'step.identification': 'Identificação',
    'step.alliances': 'Aliados e adversários',
    'alliances.title': 'Aliados e adversários',
    'alliances.description':
      'Quem a campanha conta como aliado ou adversário. Toda análise lê esta lista; você pode mudá-la depois em Dados da campanha.',
    'alliances.submit': 'Salvar e abrir a campanha',
    'alliances.skip': 'Pular',
  },
  {
    title: 'New campaign',
    'name.label': 'Campaign name',
    'activeFrom.label': 'Start (optional)',
    'activeTo.label': 'End (optional)',
    submit: 'Create campaign',
    'refused.reason': 'try again later',
    'refused.noSlots': 'There is no free slot to create a new campaign.',
    steps: 'Steps',
    'step.candidate': 'Candidature',
    'step.identification': 'Identification',
    'step.alliances': 'Allies and adversaries',
    'alliances.title': 'Allies and adversaries',
    'alliances.description':
      'Who the campaign counts as an ally or an adversary. Every analysis reads this list; you can change it later in the campaign record.',
    'alliances.submit': 'Save and open the campaign',
    'alliances.skip': 'Skip',
  },
);

export const nm = newCampaignCatalogue.t;
